import React from 'react';
import './style.scss';
import clsx from 'clsx';
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import Button from '../Shared/components/controls/Button';

import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import { Swiper } from 'swiper/react/swiper-react.js';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import { Pagination } from 'swiper';
import { withTranslation } from 'react-i18next';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CarouselNewsComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CarouselNewsComponent" />;
  }

  const IsEliteTheme = props?.fields?.IsEliteTheme?.value;
  const { i18n } = props;
  const { heading: title, text: description, link, items: cards } = props?.fields;
  const { params } = props;
  const { theme, bgColor } = params;
  const shouldRenderTitle = !!title?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderLink = !!link && link?.value?.href !== '';
  const shouldRenderCards = !!cards && cards?.length > 0;
  const bulletClassName = 'carousel-bullet';
  const bulletActiveClassName = 'carousel-bullet-active';
  const lang = i18n.language;
  const breakpoints = {
    350: {
      spaceBetween: 8,
    },
    400: {
      spaceBetween: 8,
    },
    500: {
      spaceBetween: 16,
    },
    768: {
      spaceBetween: 30,
    },
    992: {
      spaceBetween: 30,
    },
    1200: {
      spaceBetween: 30,
    },
  };
  const pagination = {
    clickable: true,
    bulletClass: bulletClassName,
    bulletActiveClass: bulletActiveClassName,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  };

  const styleBased = theme === 'textBased' ? { background: bgColor } : null;

  const isGrid = props?.params?.isGrid === '1';

  return (
    <div
      className={clsx(
        'carouselNewsComponent content',
        theme,
        IsEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        params?.Styles
      )}
      style={styleBased}
    >
      <div className="top flex-it flex-align-item-stretch flex-align-item-end flex-justify-between">
        <div className="title-desc">
          {shouldRenderTitle && (
            <div className="title">
              <Text field={title} />
            </div>
          )}
          {shouldRenderDescription && <RichText className="description" field={description} />}
        </div>
        {shouldRenderLink && <Button className="desktop btn-viewAll" link={link} />}
      </div>

      {shouldRenderCards && (
        <>
          {isGrid && (
            <div className={clsx(isGrid && 'is-grid-2')}>
              {cards?.map((item, index) => {
                const shouldRenderItemLink = !!item?.fields?.link?.value?.href;
                return (
                  <div key={index} className="swiper-slide-2">
                    <div
                      className={clsx(
                        `${
                          theme === 'textBase'
                            ? 'noTextBased'
                            : 'trigger-button-hover flex-it flex-align-item-end'
                        }`,
                        theme
                      )}
                    >
                      {!!item && <CardItem props={item.fields} theme={theme} />}
                      {shouldRenderItemLink && (
                        <a className="link" href={item?.fields?.link?.value?.href}></a>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <Swiper
            modules={[Pagination]}
            spaceBetween={30}
            pagination={pagination}
            breakpoints={breakpoints}
            autoHeight={theme === 'textBased' ? true : false}
            slidesPerView={'auto'}
            className={clsx('carousel', isGrid ? 'is-grid' : 'not-grid')}
            dir={lang === 'en' ? 'ltr' : 'rtl'}
          >
            {cards?.map((item, index) => {
              const shouldRenderItemLink = !!item?.fields?.link?.value?.href;
              return (
                <SwiperSlide
                  className={clsx(
                    `${
                      theme === 'textBase'
                        ? 'noTextBased'
                        : 'trigger-button-hover flex-it flex-align-item-end'
                    }`,
                    theme
                  )}
                  key={index}
                >
                  {!!item && <CardItem props={item.fields} theme={theme} />}
                  {shouldRenderItemLink && (
                    <a className="link" href={item?.fields?.link?.value?.href}></a>
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </>
      )}

      <div className="mobile">
        {shouldRenderLink && <Button className="btn-viewAll btn-mob" link={link} />}
      </div>
    </div>
  );
};

const CardItem = ({ props, theme }) => {
  //constants
  const link = props.link;
  //rendering
  const shouldRenderImage = !!props?.image;
  const shouldRenderTitle = !!props?.heading?.value;
  const shouldRenderText = !!props?.text?.value;
  const shouldRenderLink = !!link && link?.value?.href !== '';
  const shouldRenderTextPlace = shouldRenderTitle || shouldRenderText || shouldRenderLink;

  let classThemeBased = theme === 'textBased' ? 'pos-relative' : 'pos-static';
  //returned data
  return (
    <div className={clsx(classThemeBased, theme !== 'textBased' && 'flex-it flex-align-item-end')}>
      {shouldRenderImage && (
        <div className="picture">
          <figure>
            <Image field={props.image} />
          </figure>
        </div>
      )}
      {shouldRenderTextPlace && (
        <>
          <div className="textPlace">
            {shouldRenderTitle && <RichText className="title" field={props.heading} />}
            {shouldRenderText && <RichText className="description" field={props.text} />}

            {theme !== 'textBased' && (
              <div className="btn-item">
                {shouldRenderLink && <Button link={link} variant="contained" color="primary" />}
              </div>
            )}
          </div>
        </>
      )}
      {theme === 'textBased' && (
        <div className="btn-item">
          {shouldRenderLink && <Button link={link} variant="contained" color="primary" />}
        </div>
      )}
    </div>
  );
};

export default withTranslation()(CarouselNewsComponent);
